module.exports = __webpack_public_path__ + "img/sttrpc.8926ba89.png";